module.exports = __webpack_public_path__ + "static/media/kerem.94a8c468.png";